/* @ngInject */
function customHighLight() {
  const mappings = {
    a: String.fromCharCode(65, 97, 192, 224, 193, 225, 194, 226, 195, 227, 196, 228, 229, 258, 259),
    e: String.fromCharCode(69, 101, 200, 232, 201, 233, 202, 234, 203, 235),
    i: String.fromCharCode(73, 105, 204, 236, 205, 237, 206, 238, 207, 239),
    o: String.fromCharCode(79, 111, 210, 242, 211, 243, 212, 244, 213, 245, 214, 246),
    n: String.fromCharCode(78, 110, 209, 241),
    u: String.fromCharCode(85, 117, 217, 249, 218, 250, 219, 251, 220, 252),
    c: String.fromCharCode(67, 99, 199, 231),
    y: String.fromCharCode(89, 121, 221, 253, 159, 255),
  };

  function replacer(input, mappings) {
    return input
      .split("")
      .map(function (letter) {
        for (const mapping in mappings) {
          if (
            mapping &&
            mapping !== mappings[mapping] &&
            (mapping === letter || mappings[mapping].indexOf(letter) !== -1)
          ) {
            letter = Array.isArray(mappings[mapping]) ? mappings[mapping].join("") : "[" + mappings[mapping] + "]";
            break;
          }
        }
        return letter;
      })
      .join("");
  }

  function toRegex(input) {
    return new RegExp(replacer(escapeRegexp(input), mappings), "gi");
  }

  function escapeRegexp(queryToEscape) {
    return ("" + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
  }

  return function (matchItem, query) {
    return query && matchItem
      ? ("" + matchItem).replace(toRegex(query), '<span class="ui-select-highlight">$&</span>')
      : matchItem;
  };
}

export default customHighLight;
